





























































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../../types";
import {
    HOST
} from "../../global";
import ICountUp from 'vue-countup-v2';

@Component({
    name: "TitleCounterblock",
    components: {
        ICountUp
    }
})
export default class TitleCounterblock extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    // public endVal: number = endVal;
    delay = 1000;
    showCounter: boolean = false;
    //public endVal: number = (this as any).endVal;
    options: any = {
        useEasing: true,
        useGrouping: true,
        separator: '',
        decimal: '.',
        prefix: '',
        suffix: ''
    };
    // onReady(instance: any, CountUp: any) {
    //     const that = this;
    //     instance.update((that as any).endVal + 100);
    // }
    handleScroll(event: any) {
        if (window.pageYOffset > 1400) {
            (this as any).showCounter = true;
        } else {
            (this as any).showCounter = false;
        }
        // console.log(window.pageYOffset);
    }

    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }

}
